var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 3.10669H10.5312V1.70044C10.5312 1.24341 10.8828 0.856689 11.375 0.856689C11.832 0.856689 12.2188 1.24341 12.2188 1.70044V3.10669H13.625C14.8555 3.10669 15.875 4.12622 15.875 5.35669V16.6067C15.875 17.8723 14.8555 18.8567 13.625 18.8567H2.375C1.10938 18.8567 0.125 17.8723 0.125 16.6067V5.35669C0.125 4.12622 1.10938 3.10669 2.375 3.10669H3.78125V1.70044C3.78125 1.24341 4.13281 0.856689 4.625 0.856689C5.08203 0.856689 5.46875 1.24341 5.46875 1.70044V3.10669ZM1.8125 16.6067C1.8125 16.9231 2.05859 17.1692 2.375 17.1692H13.625C13.9062 17.1692 14.1875 16.9231 14.1875 16.6067V7.60669H1.8125V16.6067Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.7fcab3157cd6c9bf44ed8bf9c148f0b0.svg";
export { ForwardRef as ReactComponent };